import { StockLocation } from "../sdk";

export class IStockLocation extends StockLocation {
    public static readonly FIELDS: Array<string> = [
        "id", 
        "name",
        "complete_name",
        "location_id"
    ];

    public static readonly FILTER_INCLUDE = null;

    constructor(json: StockLocation) {
        super(json);
    }
}


// WEBPACK FOOTER //
// ./src/models/iStockLocation.ts